<template>
  <CardedDisplay>
    <PlainDisplay icon="" cmp_class="mt-0 pt-0">
      <b><v-icon>mdi-calendar-clock</v-icon> : </b> Business openning and
      closing time, with specific holidays programe
      <br />
      <br />
      Your viewed this business at:<b class="ml-5">{{ device_date_now }}</b>
      <small>(your device time)</small> <br />
      According to your device time:
      <v-chip label class="white--text ml-2" :color="is_business_open.color"
        ><b class=""> {{ is_business_open.msg }}</b></v-chip
      >
      <br />
      Botswana's time zone is: <b class="ml-12">Central Africa Time</b>
      <small>(CAT) - (GMT+2)</small>
      <!--country update time zone -->
      <br /><br />
      <i
        >If you are not in botswana,
        <!--country -->
        your time zone and time may be different.</i
      >
      <br />
      <i>The time above is updated every after half a minute (30 seconds)</i>
    </PlainDisplay>
    <v-row class="pl-5 pr-5 mt-5">
      <v-col>
        <v-alert
          dense
          text
          type="warning"
          v-if="is_owner && holiday_schedules.is_missing_entry == true"
          class="text-left"
        >
          <small
            >Please note that
            <strong> you are missing working hours for some holidays </strong>
            for your business, please click the
            <v-btn
              small
              class="mr-4"
              text
              :disabled="is_loading"
              :to="
                '/owner/businesses/list/view/' +
                this.business.id +
                '/holidayschedule/manage'
              "
              color="black"
            >
              Manage Holidays Schedule Info
            </v-btn>
            button to set it up.
          </small>
        </v-alert>

        <v-alert
          dense
          text
          type="warning"
          v-if="!is_owner && holiday_schedules.is_missing_entry == false"
        >
          <small
            >This
            <strong>
              business has not yet setup some holidays working hours
            </strong></small
          >
        </v-alert>
        <div class="success lighten-4 rounded pa-1">
          <div class="pt-2 pb-2 text-center h6 font-weight-black black--text">
            Specific Holidays Working Schedule
          </div>
          <div>
            <ScheduleRow
              v-for="(item, index) in holiday_schedules.items"
              :key="index"
              :left_value="item.left_value"
              :mid_value="item.mid_value"
              :right_value_1="item.right_value_1"
              :right_value_2="item.right_value_2"
              :is_header="item.is_header"
              :show_middle_value="true"
              :is_today="item.is_today"
            >
            </ScheduleRow>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row class="pl-5 pr-5 mt-5">
      <v-col>
        <v-alert
          dense
          text
          type="warning"
          v-if="is_owner && normal_schedule.is_missing_entry == true"
          class="text-left"
        >
          <small
            >Please note that
            <strong> you are missing working hours for some days </strong>
            for your business, please click the
            <v-btn
              small
              class="mr-4"
              text
              :disabled="is_loading"
              :to="
                '/owner/businesses/list/view/' +
                this.business.id +
                '/schedule/manage'
              "
              color="black"
            >
              Manage Schedule Info
            </v-btn>
            button to set it up.</small
          >
        </v-alert>

        <v-alert
          dense
          text
          type="warning"
          v-if="!is_owner && normal_schedule.is_missing_entry == false"
        >
          <small
            >This
            <strong>
              business has not yet setup some schedule information
            </strong></small
          >
        </v-alert>
        <div class="success lighten-4 rounded pa-1">
          <div class="pt-2 pb-2 text-center h6 font-weight-black black--text">
            Normal Working Schedule
          </div>

          <div>
            <ScheduleRow
              v-for="(item, index) in normal_schedule.items"
              :key="index"
              :left_value="item.left_value"
              :right_value_1="item.right_value_1"
              :right_value_2="item.right_value_2"
              :is_header="item.is_header"
              :is_today="item.is_today"
            >
            </ScheduleRow>
          </div>
        </div>
      </v-col>
    </v-row>
  </CardedDisplay>
</template>

<script>
import ServerClient from "./../lib/ServerClient";
import Utils from "./../lib/Utils";
import CardedDisplay from "./../components/CardedDisplay";
import PlainDisplay from "./../components/PlainDisplay";
import ScheduleRow from "./../components/ScheduleRow";
export default {
  name: "BusinessViewSchedule",
  components: {
    CardedDisplay,
    PlainDisplay,
    ScheduleRow,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_owner: {
      type: Boolean,
      default: false,
    },
    business: {
      type: Object,
      default: function () {
        return Utils.get_default_business();
      },
    },
    user: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  data: () => {
    return {
      device_date_now: Utils.get_today_date_str(null, true),
      interval: null,
      normal_schedule: {
        items: [],
        is_missing_entry: false,
        is_open: -1,
      },
      holiday_schedules: {
        items: [],
        is_missing_entry: false,
        is_open: -1,
        is_a_holiday_today: false,
      },
      is_business_open: {
        msg: "... Verifying Status, please wait",
        color: "default",
        is_open: -1,
        open_status: "Open or Closed",
      },
    };
  },
  methods: {
    set_normal_schedule() {
      var lst = [
        {
          left_value: "DAY",
          right_value_1: "OPENNING VALUE",
          right_value_2: "CLOSING VALUE",
          is_header: true,
          is_today: false,
        },
      ];
			var is_missing_entry = false;
			var is_open = false;
      if (this.business) {
        var days = [
          "sunday",
          "monday",
          "tuesday",
          "wednesday",
          "thursday",
          "friday",
          "saturday",
        ];
        var this_device_day = new Date().getDay();
        var device_day = days[this_device_day];
        for (var index = 0; index < days.length; index++) {
          var day = days[index];
          var op_value = this.business[day + "_openning_time_display"];
          var cl_value = this.business[day + "_closing_time_display"];
          if (op_value.length == 0) {
            op_value = "not set";
            is_missing_entry = true;
          }
          if (cl_value.length == 0) {
            cl_value = "not set";
            is_missing_entry = true;
					}
					var is_today = device_day == day;
					var is_this_one_open = false;
					if (is_today == true && op_value != "closed" && cl_value != "closed" && op_value != "not set" && cl_value != "not set") {
              //then lets get the times schedule times
              var start_x = parseFloat(this.business[day + "_openning_time_value"]); //13:26 --> 13.26 (13.26 is how we saved the time in the db)
              var closes_x = parseFloat(this.business[day + "_closing_time_value"]); //08:00 --> 8.00  (8.26 is how we saved the time in the db)
              var device_date_x = new Date();
              var now_device_hours = device_date_x.getHours();
              var now_device_mins = device_date_x.getMinutes();
              var now_device_time = parseFloat(
                now_device_hours + "." + now_device_mins
              );
              if (now_device_time >= start_x && now_device_time <= closes_x) {
								is_open = true;
								is_this_one_open = true;
              }
          }else if (is_today == true && (op_value == "not set" || cl_value != "not set")) {
						is_open = -1;
						is_this_one_open = -1;
					}
          lst.push({
            left_value: day,
            right_value_1: op_value,
            right_value_2: cl_value,
            is_header: false,
						is_today: device_day == day,
						is_open: is_this_one_open
          });
        }
      }
      this.normal_schedule = {
        items: lst,
				is_missing_entry: is_missing_entry,
				is_open: is_open
      };
    },
    set_holiday_schedule() {
      var lst = [
        {
          left_value: "DAY",
          mid_value: "DATE",
          right_value_1: "OPENNING VALUE",
          right_value_2: "CLOSING VALUE",
          is_header: true,
          is_today: false,
        },
      ];
      var DateTodayDevice = new Date();
      var TodayDeviceDate = DateTodayDevice.getDate();
      var TodayDeviceMonth = DateTodayDevice.getMonth();

      var is_missing_entry = false;
      var is_open = false;
      var is_a_holiday_today = false;
      if (this.business && this.business.app_holidays) {
        //index the business holiday entries
        var indexed_business_holidays = {};
        for (
          var index = 0;
          index < this.business.business_holliday_schedules.length;
          index++
        ) {
          var schedule = this.business.business_holliday_schedules[index];
          indexed_business_holidays[parseInt(schedule.holliday_id)] = schedule;
        }
        //go throught the application holidays config
        for (
          var index = 0;
          index < this.business.app_holidays.length;
          index++
        ) {
          var holiday = this.business.app_holidays[index];
          var dt = "";
          if (holiday.starts_on == holiday.ends_on) {
            dt = Utils.date_str_to_words(holiday.starts_on);
          } else {
            dt = Utils.date_str_to_words(holiday.starts_on);
            //+
            // " - " +
            // Utils.date_str_to_words(holiday.ends_on);
          }
          //used to detect for today
          var DateForHoliday = new Date(holiday.starts_on);
          var DateForHolidayDate = DateForHoliday.getDate();
          var DateForHolidayMonth = DateForHoliday.getMonth();
          var is_today = false;
          if (
            TodayDeviceDate == DateForHolidayDate &&
            TodayDeviceMonth == DateForHolidayMonth
          ) {
            is_today = true;
            is_a_holiday_today = true;
          }

          //look for this holiday from the business object
          if (indexed_business_holidays[parseInt(holiday.id)]) {
            var schedule = indexed_business_holidays[parseInt(holiday.id)];
            var op_value = schedule.opens;
            var cl_value = schedule.closes;
            if (op_value.length == 0) {
              op_value = "not set";
              is_missing_entry = true;
            }
            if (cl_value.length == 0) {
              cl_value = "not set";
              is_missing_entry = true;
            }
            //for the business to be oppened on this holiday it must be today
            //and having a schedule setup, thats why this logic is written here
            if (is_today == true && schedule.opens_time != "closed") {
              //then lets get the times schedule times
              var start_x = parseFloat(schedule.opens_time); //13:26 --> 13.26 (13.26 is how we saved the time in the db)
              var closes_x = parseFloat(schedule.ends_time); //08:00 --> 8.00  (8.26 is how we saved the time in the db)
              var device_date_x = new Date();
              var now_device_hours = device_date_x.getHours();
              var now_device_mins = device_date_x.getMinutes();
              var now_device_time = parseFloat(
                now_device_hours + "." + now_device_mins
              );
              if (now_device_time >= start_x && now_device_time <= closes_x) {
                is_open = true;
              }
            }
            lst.push({
              left_value: holiday.name,
              mid_value: dt,
              right_value_1: op_value,
              right_value_2: cl_value,
              is_header: false,
              is_today: is_today,
              is_open: is_open,
            });
          } else {
            lst.push({
              left_value: holiday.name,
              mid_value: dt,
              right_value_1: "not set",
              right_value_2: "not set",
              is_header: false,
              is_today: is_today,
              is_open: is_open,
            });
            is_missing_entry = true;
            if (is_today == true) {
              //if its today but you dont have an entry for the holiday
              //then
              is_open = -1;
            }
          }
        }
      } else {
        is_open = -1; //not set
      }
      this.holiday_schedules = {
        items: lst,
        is_missing_entry: is_missing_entry,
        is_open: is_open,
        is_a_holiday_today: is_a_holiday_today,
      };
    },
    set_is_business_open() {
      var msg = "";
      var color = "";
      var is_open = false;
      var open_status = open_status;
      var is_holiday_open = this.holiday_schedules.is_open;
      var is_a_holiday_today = this.holiday_schedules.is_a_holiday_today;
      var is_week_open = this.normal_schedule.is_open;

      if (is_a_holiday_today && is_holiday_open === -1) {
        //note the === strict comparison used here
        msg =
          "This business may be open or close, because there is no schedule setup for this holiday";
        color = "orange";
        is_open = -1;
        open_status = "Open or Closed";
      } else if (is_a_holiday_today && is_holiday_open === false) {
        //note the === strict comparison used here
        msg = "This business is CLOSED, by this time on this holiday";
        color = "red";
        is_open = false;
        open_status = "Closed";
      } else if (is_a_holiday_today && is_holiday_open === true) {
        //note the === strict comparison used here
        msg = "This business is OPEN, by this time on this holiday";
        color = "green";
        is_open = true;
        open_status = "Open";
      } else if (is_week_open === true) {
        //note the === strict comparison used here
        msg = "This business is OPEN";
        color = "green";
        is_open = true;
        open_status = "Open";
      } else if (is_week_open === false) {
        //note the === strict comparison used here
        msg = "This business is CLOSED";
        color = "red";
        is_open = false;
        open_status = "Closed";
      } else if (is_week_open === -1) {
        msg =
          "This business may be open or close, because there is no schedule setup for today";
        color = "orange";
        is_open = -1;
        open_status = "Open or Closed";
      }
      this.is_business_open = {
        msg: msg,
        color: color,
        is_open: is_open,
        open_status: open_status,
      };
    },
    init_schedules() {
      this.device_date_now = Utils.get_today_date_str(null, true);
      this.set_normal_schedule();
      this.set_holiday_schedule();
      this.set_is_business_open();
    },
  },
  computed: {},
  mounted() {
    var vm = this;
    vm.init_schedules();
    this.interval = setInterval(() => {
      vm.init_schedules();
    }, 30000);
    //nyd
    //delete this interval before this component
    //is destroyed in one of those life cycle methods
  },
};
</script>